export default "__VITE_ASSET__C4qIje2o__"